import { createColumnHelper } from '@tanstack/react-table'
import { TravelEvent, TravelGuideCompliance, TravelRisk } from '../../types/TravelTypes'
import { Badge } from '@radix-ui/themes'
import { IconBook } from '@tabler/icons-react'
import { formatUtcTimestamp } from '../../utils/dates'
import EllipsisWithTooltip from '../tooltip/EllipsisWithTooltip'

export const travelEventsColumns = () => {
  const columnHelper = createColumnHelper<TravelEvent>()

  const columnHelpers = [
    columnHelper.accessor('memberName', {
      header: 'Device',
      enableSorting: false,
      cell: (row) => {
        return (
          <a
            className="text-mainPurple dark:text-secondaryPurple cursor-pointer underline"
            href={`/devices/${row?.row.original.deviceIdentifier}`}
          >
            <EllipsisWithTooltip>{row?.row.original.deviceName}</EllipsisWithTooltip>
          </a>
        )
      },
      size: 200,
    }),
    columnHelper.accessor('country', {
      header: 'Country',
      enableSorting: true,
      cell: (info) => <EllipsisWithTooltip>{info.getValue()}</EllipsisWithTooltip>,
      size: 200,
    }),
    columnHelper.accessor('networkCarrier', {
      header: 'Network Carrier',
      enableSorting: true,
      cell: (info) => <EllipsisWithTooltip>{info.getValue()}</EllipsisWithTooltip>,
      size: 200,
    }),
    columnHelper.accessor('risk', {
      cell: (info) => generateRiskView(info.getValue() as TravelRisk),
      header: 'Risk',
      enableSorting: true,
      size: 100,
    }),
    columnHelper.accessor('eventTime', {
      cell: (info) => <EllipsisWithTooltip>{formatUtcTimestamp(info.getValue())}</EllipsisWithTooltip>,
      header: 'Date of Travel (UTC)',
      enableSorting: true,
      size: 120,
    }),
  ]

  return columnHelpers
}

export const generateRiskView = (status: TravelRisk) => {
  switch (status) {
    case 'HIGH':
      return (
        <div className="flex">
          <Badge className="bg-criticalBg text-criticalText">High</Badge>
        </div>
      )
    case 'MEDIUM':
      return (
        <div className="flex">
          <Badge color="orange">Medium</Badge>
        </div>
      )
    case 'LOW':
      return (
        <div className="flex">
          <Badge className="bg-successBg text-successText">Low</Badge>
        </div>
      )
    default:
      return null
  }
}

export const generateGuideView = (status: TravelGuideCompliance) => {
  switch (status) {
    case TravelGuideCompliance.ACKNOWLEDGED:
      return (
        <div className="flex items-center gap-2">
          <IconBook color="green" />
          Acknowledged
        </div>
      )
    case TravelGuideCompliance.NOT_ACKNOWLEDGED:
      return (
        <div className="flex items-center gap-2">
          <IconBook color="orange" /> Not Acknowledged
        </div>
      )
    case TravelGuideCompliance.NOT_REQUIRED:
      return (
        <div className="flex items-center gap-2">
          <IconBook color="gray" /> Not Required
        </div>
      )
    case TravelGuideCompliance.REQUIRED:
      return (
        <div className="flex items-center gap-2">
          <IconBook color="crimson" /> Required
        </div>
      )
    default:
      return null
  }
}
